import { defineComponent as _defineComponent } from 'vue'
import { ObjectType } from '@/@types/graphql-types';
import { TitleOfferFragment } from '@/features/buybox/graphql/fragments/Offer.fragment';
import BuyBoxOfferNewPresentation from '@/components/experiments/OverProviderExp/components/BuyBoxOfferNewPresentation.vue';
import { useI18n } from '@/helpers/composables/useI18n';
import { TitleDetail } from '@/interfaces/title-details-graphql';
import { BuyBoxFilterOptions, NewBuyBoxView } from '@/stores/useUserStoreTypes';
import { computed, defineAsyncComponent } from 'vue';
import { PlanOffer } from '@/features/buybox/composables/useFreeTrial';
import { useOverProviderExp } from '@/components/experiments/OverProviderExp';
import { getDisclaimerText } from '@/features/buybox/helpers/list-buybox-config';
// EXP_PROMOTED_FREE_TRIAL_REDESIGN
import { usePromotedFreeTrialRedesignExp } from '@/components/experiments/PromotedFreeTrialRedesignExp';
// EXP_PROMOTED_FREE_TRIAL_REDESIGN


export default /*#__PURE__*/_defineComponent({
  __name: 'PromotionRowOfferPresentation',
  props: {
    title: null,
    promotionOffer: null,
    packagePlan: null,
    isFallback: { type: Boolean },
    isHighlighted: { type: Boolean },
    filterOption: null,
    buyboxView: { default: NewBuyBoxView.LIST }
  },
  setup(__props: any) {

const props = __props as { title: TitleDetail, promotionOffer: TitleOfferFragment | null, packagePlan: PlanOffer | null, isFallback?: boolean, isHighlighted?: boolean, filterOption?: BuyBoxFilterOptions, buyboxView: NewBuyBoxView };

const DisclaimerButton = defineAsyncComponent(() => import('@/features/buybox/components/DisclaimerButton.vue'));



const { tc, t } = useI18n();

const { isOverProviderTitle } = useOverProviderExp({
	promotionOffer: () => props.promotionOffer,
});

const subText = computed(() => {
	if (!props.promotionOffer) return '';

	const provider = props.promotionOffer?.package.clearName;

	if (!props.isFallback) {
		return t('WEBAPP_FREE_TRIAL_TEXT', { provider });
	}

	return props.title.objectType === ObjectType.Movie
		? t('WEBAPP_WATCH_SIMILAR_MOVIES_FREE_ON_X', { provider })
		: t('WEBAPP_WATCH_SIMILAR_TV_SHOWS_FREE_ON_X', { provider });
});

// EXP_PROMOTED_FREE_TRIAL_REDESIGN - variant_1, variant_3 and variant_4 also highlight the "Other Movies" text in gold for Movies.
// variant_2 and control keep the plain, non-highlighted subText for Movies. Read directly via useExperiment (through
// the composable) instead of threading pftrVariant down as a prop, to avoid future conflicts between callers.
const { variant: pftrVariant } = usePromotedFreeTrialRedesignExp(
	() => props.promotionOffer?.package.shortName,
	() => !!props.isFallback
);
const MOVIE_HIGHLIGHT_PFTR_VARIANTS = ['variant_1', 'variant_3', 'variant_4'];
const isMovieHighlightEligible = computed(
	() => props.title.objectType === ObjectType.Movie && MOVIE_HIGHLIGHT_PFTR_VARIANTS.includes(pftrVariant.value ?? '')
);

const showHighlightedOther = computed(() => props.isHighlighted || isMovieHighlightEligible.value);
// EXP_PROMOTED_FREE_TRIAL_REDESIGN

const highlightedCTAText = computed(() => {
	if (props.title.__typename === 'Show' || props.title.__typename === 'Season') return tc('WEBAPP_OTHER_SHOWS');
	if (props.title.__typename === 'Movie') return tc('WEBAPP_OTHER_MOVIES');
	return '';
});

const disclaimerText = computed(() => {
	if (!props.promotionOffer) return null;

	return getDisclaimerText(props.promotionOffer.package.shortName, props.promotionOffer.country);
});

const showDisclaimerButton = computed(() => {
	if (!!disclaimerText.value) return true;
	return props.promotionOffer?.package.packageId === 350 && props.packagePlan?.retailPrice;
});

return { __sfc: true,DisclaimerButton, props, tc, t, isOverProviderTitle, subText, pftrVariant, MOVIE_HIGHLIGHT_PFTR_VARIANTS, isMovieHighlightEligible, showHighlightedOther, highlightedCTAText, disclaimerText, showDisclaimerButton, BuyBoxOfferNewPresentation, NewBuyBoxView }
}

})